/* here&found — TUGLO use-illustration (assets/hf-mechanism-tuglo.js).
   Verb: RETURNS. The metal carabiner clips to a bag loop, the split ring
   reaches a lock on a steel tether, then the coil draws it back to the round
   housing. The scene uses the source-confirmed 60 cm reach and does not imply
   safety, climbing or load-bearing use.

   Product cues: tall integrated carabiner, round four-screw housing, narrow
   lower neck and split key ring. Light stage; cobalt is only the steel tether
   and the 60 cm measure. */

const K = window.HFIllo.kit;
const { q, boxFill, Sh, Hand, st, INK, CREAM, Spark } = K;
const COBALT = (getComputedStyle(document.documentElement).getPropertyValue('--accent-deep') || '#1B54D6').trim();

const FLOOR_Y = 276;

function room() {
  return `
    <path ${st(INK, 2.6)} d="${q(30, FLOOR_Y, 496, FLOOR_Y - 4, 2.5)}"/>
    <!-- bag edge and attachment loop -->
    <path d="${boxFill(56, 104, 112, 164, 4)}" fill="${CREAM}" stroke="${INK}" stroke-width="2.8"/>
    <path ${st(INK, 2.2)} d="${q(83, 110, 93, 77, 5)} ${q(93, 77, 137, 78, 2)} ${q(137, 78, 149, 109, -5)}"/>
    <!-- lock/reader at the useful end -->
    <path d="${boxFill(420, 128, 54, 76, 3)}" fill="${CREAM}" stroke="${INK}" stroke-width="2.5"/>
    <circle cx="447" cy="151" r="5" fill="none" stroke="${INK}" stroke-width="1.7"/>
    <path ${st(INK, 1.5)} d="${q(434, 182, 460, 181, 1.2)}"/>`;
}

function carabiner(x, y, clipped = false) {
  return `
    <path d="M${x - 24} ${y + 40} Q${x - 34} ${y + 8} ${x - 22} ${y - 28}
      Q${x - 9} ${y - 60} ${x + 16} ${y - 56} Q${x + 36} ${y - 50} ${x + 31} ${y - 20}
      L${x + 23} ${y + 14} Q${x + 18} ${y + 32} ${x + 5} ${y + 42} Z"
      fill="${CREAM}" stroke="${INK}" stroke-width="4" stroke-linejoin="round"/>
    <path ${st(INK, 2.2)} d="${q(x + 26, y - 38, x + 18, y + 17, clipped ? -3 : 3)}"/>
    <circle cx="${x + 25}" cy="${y - 18}" r="3" fill="${INK}"/>`;
}

function housing(x, y) {
  return `
    ${Sh(x, y + 64, 45, 6)}
    <circle cx="${x}" cy="${y}" r="48" fill="${CREAM}" stroke="${INK}" stroke-width="3"/>
    <circle cx="${x}" cy="${y}" r="31" fill="none" stroke="${INK}" stroke-width="1.5"/>
    <circle cx="${x}" cy="${y}" r="3" fill="none" stroke="${INK}" stroke-width="1.4"/>
    <circle cx="${x - 31}" cy="${y - 30}" r="3" fill="${INK}"/>
    <circle cx="${x + 31}" cy="${y - 30}" r="3" fill="${INK}"/>
    <circle cx="${x - 31}" cy="${y + 30}" r="3" fill="${INK}"/>
    <circle cx="${x + 31}" cy="${y + 30}" r="3" fill="${INK}"/>
    <path d="${boxFill(x - 13, y + 44, 26, 25, 2.5)}" fill="${CREAM}" stroke="${INK}" stroke-width="2.5"/>`;
}

function ring(x, y) {
  return `<ellipse cx="${x}" cy="${y}" rx="25" ry="28" fill="none" stroke="${INK}" stroke-width="4"/>
    <path ${st(INK, 1.5)} d="${q(x - 15, y - 21, x + 17, y - 20, 2)}"/>`;
}

function tuglo(mode) {
  const out = mode === 'reach' || mode === 'unlock';
  const returning = mode === 'return';
  const hx = 254, hy = 157;
  const ringX = out ? 398 : returning ? 322 : 254;
  const ringY = out ? 217 : returning ? 224 : 243;
  return `
    ${carabiner(hx, 90, mode !== 'idle')}
    ${housing(hx, hy)}
    <path ${st(COBALT, 2.7)} d="${q(hx, hy + 68, ringX, ringY - 28, out ? -7 : returning ? -3 : 1)}"/>
    ${ring(ringX, ringY)}
    ${out ? `<path ${st(COBALT, 1.6)} stroke-dasharray="5 5" d="${q(270, 260, 388, 259, 1.5)}"/>
      <text x="309" y="251" fill="${COBALT}" font-family="ui-monospace, SFMono-Regular, Menlo, monospace" font-size="13" font-weight="700">60 cm</text>` : ''}`;
}

const POSES = {
  idle: () => room() + tuglo('idle'),
  clip: () => room() + `<g transform="translate(-92 16)">${tuglo('clip')}</g>` + Hand(172, 86, -22),
  reach: () => room() + tuglo('reach') + Hand(402, 218, 8),
  unlock: () => room() + tuglo('unlock') + Hand(410, 217, 4) + Spark(421, 159, COBALT, .8),
  return: () => room() + tuglo('return') + Hand(330, 225, 8),
  ready: () => room() + tuglo('idle'),
};

window.HFIllo.register('tuglo', {
  label: 'A retractable keychain clips to a bag, extends its steel tether up to 60 centimetres to a lock, then returns',
  night: false,
  settled: 'ready',
  phases: [['idle', 850], ['clip', 650], ['reach', 800], ['unlock', 500], ['return', 520], ['ready', 1900]],
  tags: {
    idle: 'Clip it once',
    clip: 'Carabiner on the bag',
    reach: 'Pull up to 60 cm',
    unlock: 'Use without unclipping',
    return: 'Guide it back',
    ready: 'Keys stay attached',
  },
  draw: (name) => (POSES[name] || POSES.ready)(),
});

window.HFIllo.define();
